import React from 'react';
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../placement/const";
import CancelIcon from "@material-ui/icons/Cancel";
import {ProviderEventListFilterValue, ProviderEventTypeNameMap, ProviderEventTypeValueToName} from "./domain";
import {ProviderEventListAction} from "./providerEventListReducer";
import {formatDate} from "../../common/util/date";
import pluralize from "pluralize";


type ProviderEventListFilterBadgeProps = {
    filter: ProviderEventListFilterValue
    dispatch: React.Dispatch<ProviderEventListAction>
}

export function ProviderEventListFilterBadge({filter, dispatch}: ProviderEventListFilterBadgeProps) {
    let values: Array<string> = [];


    if (filter.viewedOnly !== "") {
        values = values.concat(`Status: ${filter.viewedOnly}`);
    }

    if (filter.eventSince) {
        values = values.concat(`Since: ${formatDate(filter.eventSince)}`);
    }

    if (filter.reportSubmittedBy.length > 0) {
        values = values.concat(`Report Submitted By: ${filter.reportSubmittedBy.map(opt => opt.label).join(", ")}`);
    }

    if (filter.clients.length > 0) {
        values = values.concat(`${pluralize('Client', filter.clients.length)}: ${filter.clients.map(opt => opt.label).join(", ")}`);
    }

    let eventTypes: string[] = [];
    if (filter.eventTypes !== "") {
        splitAndRemoveEmpty(filter.eventTypes).forEach((eventType) => {
            eventTypes.push(eventType);
            values = values.concat(eventType);
        })
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            value = ProviderEventTypeValueToName.get(value) ? ProviderEventTypeValueToName.get(value)! : value;

            if (value.includes("Status:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, viewedOnly: ""}});
                return;
            }

            if (value.includes("Since:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, eventSince: null}});
                return;
            }

            if (value.includes("Report Submitted By:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportSubmittedBy: []}});
                return;
            }

            if (value.includes("Clients:") || value.includes("Client:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, clients: []}});
                return;
            }

            // event type handle
            if (eventTypes.includes(value)) {
                const newOptions = eventTypes.filter((val) => val !== value).join(SPLIT_DELIMITER);
                const newFilter = {...filter};
                newFilter["eventTypes"] = newOptions;
                dispatch({type: 'SET_FILTER', filter: newFilter});
                return;
            }
        }
    }

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {ProviderEventTypeNameMap.get(value) ? ProviderEventTypeNameMap.get(value) : value}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}


